import { tw as i } from "../../../utils/tailwind.js";
import { fluidLayoutListClass as e, fluidLayoutCardClass as a } from "./fluidLayout.helpers.js";
function c({
  cardsCount: o,
  cardIndex: s
}) {
  const t = i`col-span-1`, [, n, r] = a({ cardsCount: o, cardIndex: s });
  return [t, n, r];
}
function m(o) {
  const [, s] = e(o);
  return [i`grid-cols-1`, s];
}
export {
  c as responsiveLayoutCardClass,
  m as responsiveLayoutListClass
};
